const SEO_URL_LOADING = "SEO_URL_LOADING";
const SEO_URL_ERROR = "SEO_URL_ERROR";
const SEO_URL_SUCCESS = "SEO_URL_SUCCESS";
export { SEO_URL_LOADING, SEO_URL_ERROR, SEO_URL_SUCCESS };
